import { RateType } from '@wix/ambassador-bookings-services-v2-service/types';
export const getPaymentDescription = _ref => {
  let {
    payment,
    regionalSettingsLocale,
    paymentFormatters,
    paymentSeparator = ' | ',
    currencyDisplay = 'symbol'
  } = _ref;
  const {
    rateType,
    pricingPlanIds,
    options
  } = payment;
  const paymentDescriptions = [];
  if (rateType === RateType.CUSTOM) {
    var _payment$custom;
    paymentDescriptions.push((_payment$custom = payment.custom) == null ? void 0 : _payment$custom.description);
  } else if (rateType === RateType.FIXED) {
    var _payment$fixed, _payment$fixed2;
    paymentDescriptions.push(getFormattedCurrency({
      price: (_payment$fixed = payment.fixed) == null || (_payment$fixed = _payment$fixed.price) == null ? void 0 : _payment$fixed.value,
      locale: regionalSettingsLocale,
      currency: (_payment$fixed2 = payment.fixed) == null || (_payment$fixed2 = _payment$fixed2.price) == null ? void 0 : _payment$fixed2.currency,
      currencyDisplay
    }));
  } else if (rateType === RateType.VARIED) {
    const {
      minPrice,
      maxPrice
    } = payment.varied;
    const formattedMinPrice = getFormattedCurrency({
      price: minPrice == null ? void 0 : minPrice.value,
      locale: regionalSettingsLocale,
      currency: minPrice == null ? void 0 : minPrice.currency,
      currencyDisplay
    });
    const formattedMaxPrice = getFormattedCurrency({
      price: maxPrice == null ? void 0 : maxPrice.value,
      locale: regionalSettingsLocale,
      currency: maxPrice == null ? void 0 : maxPrice.currency,
      currencyDisplay
    });
    paymentDescriptions.push(paymentFormatters.variedPrice({
      minPrice: formattedMinPrice,
      maxPrice: formattedMaxPrice
    }));
  }
  if (paymentFormatters.pricingPlans && options != null && options.pricingPlan && pricingPlanIds != null && pricingPlanIds.length) {
    paymentDescriptions.push(paymentFormatters.pricingPlans({
      hasAnotherPaymentDescription: paymentDescriptions.length > 0
    }));
  }
  return paymentDescriptions.join(paymentSeparator);
};
export const getFormattedCurrency = _ref2 => {
  let {
    price,
    currencyDisplay = 'symbol',
    locale,
    currency
  } = _ref2;
  if (typeof price === 'string') {
    price = Number(price);
  }
  const fractionDigits = price % 1 === 0 ? 0 : 2;
  return Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay,
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits
  }).format(Number(price));
};
export const isServiceOfferedAsPricingPlan = _ref3 => {
  var _payment$options;
  let {
    payment
  } = _ref3;
  return !!(payment != null && (_payment$options = payment.options) != null && _payment$options.pricingPlan);
};
export const isServicePayable = _ref4 => {
  var _payment$options2, _payment$options3;
  let {
    payment
  } = _ref4;
  return (payment == null || (_payment$options2 = payment.options) == null ? void 0 : _payment$options2.online) || (payment == null || (_payment$options3 = payment.options) == null ? void 0 : _payment$options3.inPerson);
};
const ENABLE_USING_ARCHIVED_PLANS_EXPERIMENT = 'specs.bookings.EnableUsingArchivedPlans';
export const isServiceHasPricingPlanError = _ref5 => {
  let {
    payment,
    isPricingPlanInstalled,
    experiments
  } = _ref5;
  const isUsingArchivedPlansEnabled = experiments.enabled(ENABLE_USING_ARCHIVED_PLANS_EXPERIMENT);
  return isServiceOfferedAsPricingPlan({
    payment
  }) && !isServicePayable({
    payment
  }) && (!isPricingPlanInstalled || !isUsingArchivedPlansEnabled && !isServiceConnectedToPricingPlan({
    payment
  }));
};
export const isServiceConnectedToPricingPlan = _ref6 => {
  var _payment$pricingPlanI;
  let {
    payment
  } = _ref6;
  return !!(payment != null && (_payment$pricingPlanI = payment.pricingPlanIds) != null && _payment$pricingPlanI.length);
};
export const getPriceText = () => {};
//# sourceMappingURL=payment.js.map